import Vue from 'vue';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../lib/utils/consts";
import { CompNameTag } from './UcdToolbar/CompPathBreadcrumb';
// 小于这个值的时候隐藏掉英文名称
const MIN_NO_WRAP_WIDTH = 350;
export const RightTopCorner = Vue.extend({
  name: 'RightTopCorner',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  render() {
    var _this$designer$$refs$;
    const h = arguments[0];
    const {
      uc,
      designer
    } = this;
    const {
      renderer,
      compPath
    } = designer;
    const {
      propPanelHeader,
      propPanelHeaderTitleSuffix
    } = designer.$scopedSlots;
    const activeComp = propPanelHeader && designer.activeComp;
    // TODO: 按照toolbar来限制RightTopCorner的max-height更好 但是目前来说省略掉英文id之后能装的下
    const asideRightWidth = (_this$designer$$refs$ = this.designer.$refs.asideRight) === null || _this$designer$$refs$ === void 0 ? void 0 : _this$designer$$refs$.$el.getBoundingClientRect().width;
    const scopeSlotsParams = {
      uc,
      designer,
      renderer,
      comp: activeComp,
      compPath,
      compMeta: designer.activeCompMeta
    };
    return h("div", {
      "class": "uc-designer-rtCornerFixer"
    }, [h(CompNameTag, {
      "attrs": {
        "compPath": compPath,
        "hideComponentId": asideRightWidth < MIN_NO_WRAP_WIDTH
      }
    }, [propPanelHeaderTitleSuffix && h("template", {
      "slot": 'suffix'
    }, [" ", propPanelHeaderTitleSuffix(scopeSlotsParams)])]), !!propPanelHeader && !!activeComp && propPanelHeader(scopeSlotsParams)]);
  }
});
//# sourceMappingURL=RightTopCorner.js.map
